import React from 'react';
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import './FullWidthLayout.css';
import {IconType} from "react-icons";
import {Panel, PanelGroup, PanelResizeHandle} from "react-resizable-panels";


function FullWidthLayout({title, mainContent, actionButton, icon, showBreadcrumbs = true, description = null, stretched=false, sideContent=null}: {
    title: string,
    mainContent: React.ReactNode,
    actionButton?: React.ReactNode | null | undefined,
    icon?: React.ReactNode | null | undefined,
    showBreadcrumbs?: boolean,
    description?: string | null | undefined,
    stretched?: boolean,
    sideContent?: React.ReactNode | null | undefined
}) {
    return <div className={"full-width-layout"+(stretched ? " stretched" : "")}>
        <Header />
        {showBreadcrumbs? <Breadcrumbs /> : null }
        <div className="main-content">
            <PanelGroup direction="horizontal">
                <Panel minSize={25} order={1} className="left-content">
                    <div className="main-content-centered">
                        <div id="full-width-layout-top">
                            <div className="title-elements">
                                {icon? <div id="icon">{icon}</div>: null}
                                <div id="title">{title}</div>
                                {description ? <div id="description">{description}</div> : null}
                            </div>
                            <div id="action">{actionButton ? actionButton : null}</div>
                        </div>
                        <div id="full-width-layout-content">
                            {mainContent}
                        </div>
                    </div>
                </Panel>
                {sideContent ? <>
                    <PanelResizeHandle id="resize-handle" />
                    <Panel minSize={25} order={2} className="right-content">
                        {sideContent}
                    </Panel>
                </>: null
                }
            </PanelGroup>
        </div>
        <div className="footer-wrapper">
            <Footer />
        </div>
    </div>
}

export default FullWidthLayout
